    // LECTEUR VIDEO
    document.addEventListener('DOMContentLoaded', function () {
      const videosTesti = document.querySelectorAll('.mm-content-video, .mm-content-video-mobile');

      videosTesti.forEach((videoContainer) => {
          const video = videoContainer.querySelector('video');
          const playBtn = videoContainer.querySelector('.play-btn');
          const backgroundFilter = videoContainer.querySelector('.mm-background-image-filter-cvi');
          const textVideo = videoContainer.querySelector('.mm-text-bottom-video');

          playBtn.addEventListener('click', () => {
              video.play();
          });

          video.addEventListener('play', () => {
              playBtn.style.opacity = '0';
              textVideo.style.display = 'none';
              backgroundFilter.style.display = 'none';
              video.controls = true;
          });

          video.addEventListener('pause', () => {
              playBtn.style.opacity = '1';
              backgroundFilter.style.display = 'block';
              textVideo.style.display = 'block';
              video.controls = false;
          });

          //scroll pour mettre en pause la vidéo
          window.addEventListener('scroll', () => {
              if (!isElementInViewport(videoContainer)) {
              video.pause();
              }
          });
      });

      // Fonction pour vérifier si un élément est dans la vue
      function isElementInViewport(el) {
          const rect = el.getBoundingClientRect();
          return (
              rect.top >= 0 &&
              rect.left >= 0 &&
              rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
      }
  });
